module.exports = __webpack_public_path__ + "img/11.6a4ecf31.jpg";